import React from "react";
import "./courses-details.css";
import {
  CommonBanner,
  CourseDetailSection,
  Footer,
  Header,
  SearchSimilarSIdeBar,
} from "../../components";
import { C, FONT } from "../../constants/mq";

import images from "../../assets";
const dataToSend = {
  bannerImg: images["courses-detail"],
  bannerHeading: "Creative English & Reading",
  path: [
    {
      link: "/our-courses",
      name: "Our Courses",
    },
    {
      link: "#",
      name: "Creative English & Reading",
    },
  ],
};

// Macquarie look (src/constants/mq.js) for the page frame: the 1072px content
// column, and the sidebar as a plain white card with a hairline border
// instead of the 20px-radius floating panel. Scoped to this page; the
// section's own styles live in CourseDetailSection.
const css = `
.courses-detail-page { background: #ffffff; font-family: ${FONT}; }
.courses-detail-page .center-content.container {
  max-width: 1072px; padding: 0 24px; gap: 48px;
  justify-content: space-between; align-items: flex-start;
}
.courses-detail-page .middle-box { flex: 1 1 auto; width: auto; min-width: 0; }
.courses-detail-page .sidebar-courses-sec {
  flex: 0 0 300px; max-width: 300px; height: auto; margin: 56px 0 72px; padding: 22px;
  background: #ffffff; border: 1px solid ${C.line}; border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
}
.courses-detail-page .stardetail-icon { display: none; }
.courses-detail-page .sidebar-courses-sec .title-hd {
  font-family: inherit; font-size: 15px; font-weight: 700; line-height: 1.4;
  color: ${C.ink}; margin: 0 0 10px;
}
.courses-detail-page .sim-top-bar .title-hd { margin: 0; }
.courses-detail-page .search-box .form-control {
  min-height: 42px; border-radius: 4px; border-color: ${C.line}; font-size: 14px; color: ${C.ink};
}
.courses-detail-page .search-box .form-control:focus {
  border-color: ${C.red}; box-shadow: 0 0 0 3px rgba(166, 25, 46, 0.12);
}
.courses-detail-page .sim-courses,
.courses-detail-page .trial-courses { border-bottom: 1px solid ${C.line}; }
.courses-detail-page .view-courses a {
  font-family: inherit; font-size: 13px; font-weight: 600; color: ${C.red}; text-decoration: none;
}
.courses-detail-page .view-courses a:hover { color: ${C.redDark}; text-decoration: underline; }
.courses-detail-page .sim-courses-list { gap: 12px; align-items: center; padding: 8px 0; }
.courses-detail-page .sim-courses-list .img-lf { border-radius: 4px; border-color: ${C.line}; }
.courses-detail-page .sim-cours-hd a {
  font-family: inherit; font-size: 14px; font-weight: 700; line-height: 1.4; color: ${C.ink}; padding: 0;
}
.courses-detail-page .sim-cours-hd a:hover { color: ${C.red}; }
.courses-detail-page .sim-course-dt {
  font-family: inherit; font-size: 12.5px; line-height: 1.4; color: ${C.muted}; padding: 0; margin: 2px 0 0;
}
.courses-detail-page .sidebar-courses-sec .strategy-list ul li {
  display: flex; align-items: baseline; gap: 10px; padding: 7px 0;
  font-family: inherit; font-size: 14px; font-weight: 600; line-height: 1.5; color: ${C.ink};
}
.courses-detail-page .sidebar-courses-sec .strategy-list ul li:before {
  content: ""; flex-shrink: 0; width: 6px; height: 6px; margin: 0; padding: 0;
  border: 0; border-radius: 0; background: ${C.bright}; transform: translateY(-2px);
}
.courses-detail-page .sidebar-courses-sec .strategy-list ul li a {
  font-family: inherit; font-size: 14px; font-weight: 600; line-height: 1.5; color: ${C.ink};
}
.courses-detail-page .sidebar-courses-sec .strategy-list ul li a:hover { color: ${C.red}; }
@media (max-width: 991px) {
  .courses-detail-page .center-content.container { flex-direction: column-reverse; gap: 0; }
  .courses-detail-page .middle-box { width: 100%; }
  .courses-detail-page .sidebar-courses-sec { flex: none; width: 100%; max-width: none; margin: 40px 0 0; }
}
`;

function CourseDetails() {
  return (
    <div class="courses-detail-page">
      <style>{css}</style>
      <Header />
      <CommonBanner {...dataToSend} />
      <div class="center-content container">
        <CourseDetailSection />
        <SearchSimilarSIdeBar />
      </div>
      <Footer />
    </div>
  );
}

export default CourseDetails;
